// ── API Endpoints (SANS préfixe /api — le client axios l'ajoute) ──

export const API_ENDPOINTS = {
  TICKETS: {
    LIST: "/tickets",
    MERCURE_TOPIC: "/api/tickets",
    METRICS: "/tickets/metrics",
    DETAIL: (id: number | string) => `/tickets/${id}` as const,
    PROPOSE_SOLUTION: (id: number | string) => `/tickets/${id}/propose-solution` as const,
    VALIDATE_SOLUTION: (id: number | string) => `/tickets/${id}/validate-solution` as const,
    REJECT_SOLUTION: (id: number | string) => `/tickets/${id}/reject-solution` as const,
    CLOSE: (id: number | string) => `/tickets/${id}/close` as const,
    REOPEN: (id: number | string) => `/tickets/${id}/reopen` as const,
    COMMENTS: (id: number | string) => `/tickets/${id}/comments` as const,
    ATTACHMENTS: (id: number | string) => `/tickets/${id}/attachments` as const,
    DELETE: (id: number | string) => `/tickets/${id}` as const,
  },

  TICKET_COMMENTS: {
    LIST: (ticketId: number | string) => `/tickets/comments?ticket=${ticketId}` as const,
    CREATE: "/tickets/comments",
  },

  TICKET_ATTACHMENTS: {
    UPLOAD: (ticketId: number | string) => `/tickets/attachments?ticket=${ticketId}` as const,
    DELETE: (id: number | string) => `/tickets/attachments/${id}` as const,
    DOWNLOAD: (id: number | string) => `/tickets/attachments/${id}/download` as const,
  },

  USERS: "/users",
} as const;

// ── State machine transitions (miroir BE TicketStatus) ──
export const TICKET_TRANSITIONS = {
  open: ["proposition_solution", "closed"],
  proposition_solution: ["resolved", "open"],
  resolved: ["closed"],
  closed: ["open"],
} as const;

// ── Frontend Routes ──
export const ROUTES = {
  TICKETS: {
    LIST: "/tickets",
    CREATE: "/tickets/create",
    VIEW: "/tickets/$id/view",
    EDIT: "/tickets/$id/edit",
  },
} as const;
